/**
 * avatars/avatar-builder/builder-dimensions.js
 * Tính toán kích thước tỷ lệ cơ thể (Body Morphs) và khởi tạo Khung chậu (Pelvis)
 */

import * as THREE from 'three';

export function computeDimensions(config) {
  const bodyType = config.bodyType || 'normal';

  // Kích thước cơ sở (Streamlined: 2 chân nối thẳng khít với thân, áo thẳng xuống quần)
  let torsoH = 0.6;
  let torsoW = 0.4;
  let torsoD = 0.2;

  let headSize = 0.42;

  let legH = 0.65;
  // Tay dài tới giữa đùi (trước đây 0.58 chỉ chạm hông trông cụt)
  let armH = 0.7;
  let armW = 0.16;
  let armD = 0.16;

  // Biến thể theo dáng người (Body Morphs)
  if (bodyType === 'muscular') {
    // Cơ bắp: vai nở, ngực rộng, bắp tay to
    torsoH = 0.6;
    torsoW = 0.48;
    torsoD = 0.24;
    armW = 0.2;
    armD = 0.2;
  } else if (bodyType === 'tall_lean') {
    // Cao gầy: thân kéo dài, tay chân mảnh khảnh
    torsoH = 0.66;
    torsoW = 0.36;
    torsoD = 0.18;
    armH = 0.76;
    armW = 0.14;
    armD = 0.14;
    legH = 0.72;
  } else if (bodyType === 'child') {
    // Trẻ em: đầu to tỉ lệ chibi, thân và chân ngắn
    headSize = 0.46;
    torsoH = 0.46;
    torsoW = 0.36;
    torsoD = 0.18;
    armH = 0.52;
    legH = 0.46;
  } else if (bodyType === 'elder') {
    // Người già: chiều cao hơi chùng xuống
    legH = 0.6;
    torsoH = 0.58;
  }

  // Đảm bảo 100% Streamlined: 2 chân khép khít có bề rộng và độ sâu bằng đúng thân mình (áo nối thẳng xuống quần)
  const legW = torsoW / 2;
  const legD = torsoD;

  return { legH, legW, legD, torsoH, torsoW, torsoD, headSize, armH, armW, armD, bodyType };
}

export function setupPelvis(avatar, legH) {
  const pelvis = new THREE.Group();
  pelvis.position.y = legH;
  avatar.root.add(pelvis);
  avatar.parts.pelvis = pelvis;
  avatar.parts.basePelvisY = legH;
  return pelvis;
}
